export default function WebshopNavigation() {
  const cls = 'visible';
  const searchBar = document.querySelector<HTMLDivElement>('.empori-primeflow-header-search-fullwidth.mobile');
  let lastScroll = window.scrollY;
  
  function setCls(currentY: number, lastY: number) {
    if (!searchBar) {
      return;
    }
    
    if (lastY > currentY) {
      searchBar.classList.add(cls);
      return;
    }

    if (currentY > searchBar.clientHeight) {
      searchBar.classList.remove(cls);
      return;
    }

    searchBar.classList.add(cls);
  }

  window.addEventListener('scroll', () => {
    const { scrollY } = window;

    setCls(scrollY, lastScroll);
    lastScroll = scrollY;
  });
}